/* ELIVE JEWELRY — theme.js
   Handles: mobile menu, search drawer, cart drawer (AJAX), variant selection,
   quantity steppers, accordions, quick add, wishlist (localStorage-free session demo)
*/
(function () {
  'use strict';

  const qs = (s, ctx) => (ctx || document).querySelector(s);
  const qsa = (s, ctx) => Array.from((ctx || document).querySelectorAll(s));

  /* ---------- Generic drawer open/close ---------- */
  function bindDrawer(triggerSelector, drawer) {
    qsa(triggerSelector).forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        openDrawer(drawer);
      });
    });
  }
  function openDrawer(drawer) {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer(drawer) {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  document.addEventListener('DOMContentLoaded', () => {
    /* Mobile nav */
    const mobileNav = qs('#mobile-nav');
    bindDrawer('[data-mobile-nav-open]', mobileNav);
    qsa('[data-mobile-nav-close]', mobileNav).forEach((b) => b.addEventListener('click', () => closeDrawer(mobileNav)));

    /* Search drawer */
    const searchDrawer = qs('#search-drawer');
   qsa('[data-search-open]').forEach(button => {
  button.addEventListener('click', () => {
    window.location.href = '/search';
  });
});
    qsa('[data-search-close]', searchDrawer).forEach((b) => b.addEventListener('click', () => closeDrawer(searchDrawer)));

    /* Filters drawer (mobile, collection page) */
    const filtersDrawer = qs('#filters-drawer');
    bindDrawer('[data-filters-open]', filtersDrawer);
    qsa('[data-filters-close]', filtersDrawer).forEach((b) => b.addEventListener('click', () => closeDrawer(filtersDrawer)));

    /* Cart drawer */
    const cartDrawer = qs('#cart-drawer');
    bindDrawer('[data-cart-drawer-open]', cartDrawer);
    qsa('[data-cart-drawer-close]', cartDrawer).forEach((b) => b.addEventListener('click', () => closeDrawer(cartDrawer)));
    qsa('.cart-drawer__overlay, .mobile-nav__overlay, .search-drawer__overlay, .filters-drawer__overlay').forEach((ov) => {
      ov.addEventListener('click', () => {
        closeDrawer(mobileNav);
        closeDrawer(searchDrawer);
        closeDrawer(cartDrawer);
        closeDrawer(filtersDrawer);
      });
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        closeDrawer(mobileNav);
        closeDrawer(searchDrawer);
        closeDrawer(cartDrawer);
        closeDrawer(filtersDrawer);
      }
    });

    /* Accordions (product page: description, care, shipping) */
    qsa('.accordion-item__header').forEach((header) => {
      header.addEventListener('click', () => {
        const item = header.closest('.accordion-item');
        const panel = qs('.accordion-item__panel', item);
        const isOpen = item.classList.contains('is-open');
        item.classList.toggle('is-open', !isOpen);
        panel.style.maxHeight = !isOpen ? panel.scrollHeight + 'px' : '0px';
      });
    });

    /* Quantity steppers */
    qsa('[data-qty-wrapper]').forEach((wrap) => {
      const input = qs('input', wrap);
      qs('[data-qty-minus]', wrap)?.addEventListener('click', () => {
        input.value = Math.max(1, parseInt(input.value || '1', 10) - 1);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      qs('[data-qty-plus]', wrap)?.addEventListener('click', () => {
        input.value = parseInt(input.value || '1', 10) + 1;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    /* Product gallery thumbnails */
    qsa('[data-gallery-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const gallery = thumb.closest('[data-gallery]');
        const mainImg = qs('[data-gallery-main] img', gallery);
        mainImg.src = thumb.dataset.fullSrc || thumb.src;
        qsa('[data-gallery-thumb]', gallery).forEach((t) => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });

   qsa('[data-wishlist-toggle]').forEach((btn) => {
  const productHandle = btn.dataset.productHandle;
  if (!productHandle) return;

  let wishlist = [];

  try {
    wishlist = JSON.parse(localStorage.getItem('eliveWishlist') || '[]');
  } catch (e) {
    wishlist = [];
  }

  if (wishlist.includes(productHandle)) {
    btn.classList.add('is-active');
  }

  btn.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
           try { wishlist = JSON.parse(localStorage.getItem('eliveWishlist') || '[]'); } catch (err) { wishlist = []; }

    if (wishlist.includes(productHandle)) {
      wishlist = wishlist.filter(handle => handle !== productHandle);
      btn.classList.remove('is-active');
    } else {
      wishlist.push(productHandle);
      btn.classList.add('is-active');
    }

    localStorage.setItem('eliveWishlist', JSON.stringify(wishlist));
  });
});

    initVariantPickers();
    initAddToCartForms();
    updateCartDrawer(false);
  });

  /* ---------- Variant selection ---------- */
  function initVariantPickers() {
    qsa('[data-product-form]').forEach((form) => {
      const productJson = qs('[data-product-json]', form);
      if (!productJson) return;
      let product;
      try {
        product = JSON.parse(productJson.textContent);
      } catch (err) {
        return;
      }

      const optionInputs = qsa('[data-option-input]', form);
            const priceScope = form.closest('.product__info') || document;
      const priceEl = qs('[data-product-price]', priceScope);
      const compareEl = qs('[data-product-compare-price]', priceScope);
      const skuEl = qs('[data-product-sku]', form);
      const stockEl = qs('[data-product-stock]', form);
      const addBtn = qs('[data-add-to-cart]', form);
      const buyNowBtn = qs('[data-buy-now]', form);
      const variantIdInput = qs('[data-variant-id]', form);

      function currentSelection() {
        return optionInputs
          .filter((el) => (el.type !== 'radio' && el.tagName !== 'BUTTON') || el.classList.contains('is-selected') || el.checked)
          .map((el) => el.value);
      }

      function findVariant() {
        const groups = {};
        qsa('[data-option-group]', form).forEach((group) => {
          const selected = qs('.is-selected', group) || qs('input:checked', group);
          if (selected) groups[group.dataset.optionGroup] = selected.dataset.value || selected.value;
        });
        return product.variants.find((v) =>
          v.options.every((optVal, idx) => {
            const key = Object.keys(groups)[idx];
            return groups[key] === undefined || groups[key] === optVal;
          })
        );
      }

      function render() {
        const variant = findVariant();
        if (!variant) {
          if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'לא זמין'; }
          return;
        }
        if (variantIdInput) variantIdInput.value = variant.id;
        if (priceEl) priceEl.textContent = formatMoney(variant.price);
        if (compareEl) {
          if (variant.compare_at_price > variant.price) {
            compareEl.textContent = formatMoney(variant.compare_at_price);
            compareEl.style.display = '';
          } else {
            compareEl.style.display = 'none';
          }
        }
        if (skuEl) skuEl.textContent = variant.sku || '';
        if (stockEl) {
          stockEl.classList.remove('product__stock--in', 'product__stock--low', 'product__stock--out');
          if (!variant.available) {
            stockEl.textContent = 'אזל מהמלאי';
            stockEl.classList.add('product__stock--out');
          } else if (variant.inventory_quantity !== undefined && variant.inventory_quantity <= 3 && variant.inventory_quantity > 0) {
            stockEl.textContent = 'נותרו ' + variant.inventory_quantity + ' יחידות בלבד';
            stockEl.classList.add('product__stock--low');
          } else {
            stockEl.textContent = 'במלאי — מוכן למשלוח';
            stockEl.classList.add('product__stock--in');
          }
        }
        if (addBtn) {
          addBtn.disabled = !variant.available;
          addBtn.textContent = variant.available ? 'הוספה לסל' : 'אזל מהמלאי';
        }
        if (buyNowBtn) buyNowBtn.disabled = !variant.available;

        /* update gallery to variant image if present */
        if (variant.featured_image) {
          const mainImg = qs('[data-gallery-main] img', form.closest('.product') || document);
          if (mainImg) mainImg.src = variant.featured_image.src || variant.featured_image;
        }
      }

      qsa('[data-option-group] [data-option-value]', form).forEach((el) => {
        el.addEventListener('click', () => {
          const group = el.closest('[data-option-group]');
          qsa('[data-option-value]', group).forEach((s) => s.classList.remove('is-selected'));
          el.classList.add('is-selected');
          render();
        });
      });

      render();
    });
  }

  /* ---------- Add to cart (AJAX) ---------- */
  function initAddToCartForms() {
    qsa('[data-product-form]').forEach((form) => {
      form.addEventListener('submit', (e) => {
        e.preventDefault();
        const btn = qs('[data-add-to-cart]', form);
        const formData = new FormData(form);
        if (btn) { btn.disabled = true; btn.dataset.originalText = btn.textContent; btn.textContent = 'מוסיף...'; }

        fetch(window.Shopify?.routes?.root ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(Object.fromEntries(formData)),
        })
          .then((res) => res.json())
          .then(() => {
            updateCartDrawer(true);
          })
          .catch(() => {
            /* Fallback: standard form submit if AJAX fails */
            form.submit();
          })
          .finally(() => {
            if (btn) { btn.disabled = false; btn.textContent = btn.dataset.originalText || 'הוספה לסל'; }
          });
      });
    });

    qsa('[data-buy-now]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const form = btn.closest('[data-product-form]');
        const formData = new FormData(form);
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(Object.fromEntries(formData)),
        }).then(() => { window.location.href = '/checkout'; });
      });
    });
  }

  /* ---------- Cart drawer refresh ---------- */
  function updateCartDrawer(open) {
    fetch('/cart?view=drawer')
      .then((res) => res.text())
      .then((html) => {
        const body = qs('#cart-drawer-body');
        if (body) {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newBody = doc.querySelector('#cart-drawer-body');
          if (newBody) body.innerHTML = newBody.innerHTML;
        }
      })
      .catch(() => {})
      .finally(() => {
        fetch('/cart.js')
          .then((r) => r.json())
          .then((cart) => {
            qsa('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; });
          })
          .catch(() => {});
        if (open) openDrawer(qs('#cart-drawer'));
      });
  }
  document.addEventListener('cart:refresh', function() {
  updateCartDrawer(true);
});
  window.EliveTheme = window.EliveTheme || {};
  window.EliveTheme.updateCartDrawer = updateCartDrawer;

  function formatMoney(cents) {
    const value = (cents / 100).toFixed(2).replace('.00', '');
    return '₪' + value;
  }

  /* ---------- Signup popup ---------- */
  function initSignupPopup() {
    const overlay = qs('[data-popup-overlay]');
    if (!overlay) return;

    const SESSION_KEY = 'elive_popup_dismissed_session';
    const delaySeconds = parseFloat(overlay.dataset.delay || '2');
    const forceOpen = overlay.hasAttribute('data-force-open');

    function openPopup() {
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    function closePopup() {
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      /* remembered only for this browsing session — closing the tab/browser clears it,
         so the popup shows again on a genuinely new visit, but won't re-open on every
         click/page navigation within the same visit */
      try {
        sessionStorage.setItem(SESSION_KEY, '1');
      } catch (e) {
        /* ignore (e.g. private mode) */
      }
    }

    qsa('[data-popup-close]', overlay).forEach((btn) => btn.addEventListener('click', closePopup));
    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) closePopup();
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) closePopup();
    });

    /* keep the readable date value in sync with the hidden note field the customer form submits */
    const birthdateInput = qs('#PopupBirthdate', overlay);
    const noteHidden = qs('#PopupNoteHidden', overlay);
    const nameInput = qs('#PopupName', overlay);
    const firstNameHidden = qs('#PopupFirstNameHidden', overlay);
    const lastNameHidden = qs('#PopupLastNameHidden', overlay);
    const popupForm = document.getElementById('PopupForm');
    if (popupForm) {
      popupForm.addEventListener('submit', () => {
        if (birthdateInput && noteHidden && birthdateInput.value) {
          noteHidden.value = 'תאריך לידה: ' + birthdateInput.value;
        }
        if (nameInput && firstNameHidden && lastNameHidden) {
          const parts = nameInput.value.trim().split(/\s+/);
          firstNameHidden.value = parts.shift() || '';
          lastNameHidden.value = parts.join(' ');
        }
      });
    }

    /* after a form submission the page reloads — reopen immediately to show the success/error state */
    if (forceOpen) {
      openPopup();
      return;
    }

    /* testing helper: add ?popup=1 to the URL to force it open regardless of the dismissed state */
    const forceViaUrl = new URLSearchParams(window.location.search).get('popup') === '1';

    let dismissedThisSession = false;
    try {
      dismissedThisSession = sessionStorage.getItem(SESSION_KEY) === '1';
    } catch (e) {
      /* sessionStorage unavailable — treat as never dismissed */
    }
    if (!forceViaUrl && dismissedThisSession) return;

    setTimeout(openPopup, delaySeconds * 1000);
  }

  /* ---------- Newsletter form (footer) — same name/birthdate sync as the popup ---------- */
  function initNewsletterForm() {
    const form = document.getElementById('NewsletterForm');
    if (!form) return;

    const nameInput = qs('#NewsletterName', form);
    const firstNameHidden = qs('#NewsletterFirstNameHidden', form);
    const lastNameHidden = qs('#NewsletterLastNameHidden', form);
    const birthdateInput = qs('#NewsletterBirthdate', form);
    const noteHidden = qs('#NewsletterNoteHidden', form);

    form.addEventListener('submit', () => {
      if (nameInput && firstNameHidden && lastNameHidden) {
        const parts = nameInput.value.trim().split(/\s+/);
        firstNameHidden.value = parts.shift() || '';
        lastNameHidden.value = parts.join(' ');
      }
      if (birthdateInput && noteHidden && birthdateInput.value) {
        noteHidden.value = 'תאריך לידה: ' + birthdateInput.value;
      }
    });
  }

  document.addEventListener('DOMContentLoaded', initSignupPopup);
  document.addEventListener('DOMContentLoaded', initNewsletterForm);

  /* ---------- Transparent overlay header (homepage hero only) ---------- */
  function initTransparentHeader() {
    if (!document.body.classList.contains('template-index')) return;
    const header = qs('.site-header');
    const announcementBar = qs('.announcement-bar');
    const hero = qs('.hero');
    if (!header || !hero) return;

    function syncOverlap() {
      // pull the hero up underneath the announcement bar + header by their combined
      // rendered height, so the (transparent) bar and header visually float on top of the hero image
      const barHeight = announcementBar ? announcementBar.offsetHeight : 0;
      hero.style.marginTop = '-' + (barHeight + header.offsetHeight) + 'px';
    }
    syncOverlap();
    window.addEventListener('resize', syncOverlap);

    function onScroll() {
      const threshold = ((announcementBar ? announcementBar.offsetHeight : 0) + header.offsetHeight) * 0.6;
      const scrolledPast = window.scrollY > threshold;
      header.classList.toggle('is-scrolled', scrolledPast);
    }
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  document.addEventListener('DOMContentLoaded', initTransparentHeader);

  /* ---------- Mobile nav submenu accordion ---------- */
  function initMobileSubmenus() {
    qsa('[data-mobile-submenu-toggle]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        btn.closest('.mobile-nav__item--has-children').classList.toggle('is-open');
      });
    });
  }
  document.addEventListener('DOMContentLoaded', initMobileSubmenus);
})();
/* ELIVE: החלפת תמונה בנגיעה בטלפון */
(function () {
  if (!('ontouchstart' in window)) return;
  var active = null;
  function clear() { if (active) { active.classList.remove('is-touched'); active = null; } }
  document.addEventListener('touchstart', function (e) {
    var wrap = e.target.closest && e.target.closest('.product-card__media-wrap');
    if (wrap !== active) clear();
    if (wrap && wrap.querySelector('.product-card__img--back')) {
      wrap.classList.add('is-touched');
      active = wrap;
    }
  }, { passive: true });
  document.addEventListener('touchend', function () { setTimeout(clear, 600); }, { passive: true });
  document.addEventListener('touchcancel', function () { setTimeout(clear, 600); }, { passive: true });
})();